export default __webpack_public_path__ + "static/media/1958.3c5b537a.png";